module.exports = require('./src/connection')



//////////////////
// WEBPACK FOOTER
// ./~/easemob-kefu-webim/index.js
// module id = 136
// module chunks = 0